<script>
  import Contact from "./Contact.svelte";
  import Rik from "./Rik.svelte";
  import Navigation from "./Navigation.svelte";
  import Portfolio from "./Portfolio.svelte";

  let rikContainer;
  let portfolioContainer;
  let contactContainer;

  let mainHeight = 0;
</script>

<style>
  header {
    z-index: 1;
    background-color: var(--foreground-color);
    position: fixed;
    width: 100%;
  }

  main {
    display: flex;
    flex-direction: column;
    background-color: var(--background-color);
    padding-top: 3.375rem;
    margin-bottom: var(--size-xxxl); /* Same as <footer /> height */
  }

  footer {
    z-index: -1;
    position: fixed;
    bottom: 0;
    width: 100%;
    color: var(--background-color);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--size-m);
    flex-direction: column;
    height: var(--size-xxxl); /* Same as <main /> margin-bottom */
  }

  footer p {
    margin: 0 var(--size-s);
  }

  footer #links {
    display: flex;
  }

  footer #copyright {
    color: var(--navigation-link-color);
    font-size: var(--size-s);
    margin-top: var(--size-xs);
  }
</style>

<header>
  <Navigation
    {rikContainer}
    {portfolioContainer}
    {contactContainer}
    {mainHeight} />
</header>

<main bind:clientHeight={mainHeight}>
  <div bind:this={rikContainer}>
    <Rik />
  </div>
  <div bind:this={portfolioContainer}>
    <Portfolio />
  </div>
  <div bind:this={contactContainer}>
    <Contact />
  </div>
</main>

<footer>
  <div id="links">
    <p>KvK 53840828</p>
    <p>
      <a href="https://www.linkedin.com/in/rikdekker1988/" target="_blank">
        LinkedIn
      </a>
    </p>
  </div>

  <div id="copyright">
    <p>&copy; 2020 Rik Dekker Design</p>
  </div>
</footer>
